/**
 * Test uniqueness against lowercased locale, but preserve the original casing
 * if a user wants to add en-US or en-us or EN-US they can add these variations
 * (eventually will want to limit them to only en-US)
 * but should only be able to add one version of them
 * e.g., if user adds "en-US, en-CA, en-us" we will only return "en-US, en-CA"
 * the following should return unique locales (regardless of case)
 *
 * @param locales - current locales
 * @param newLocale - new locale to add
 * @returns a list of unique locales including both new locales and existing locales
 */
export const getUniqueLocales = (locales: string[], newLocale: string) => {
  const isUniqueLocale = !locales.find(
    (locale) => locale.toLowerCase().trim() === newLocale.toLowerCase().trim(),
  );
  return isUniqueLocale && !!newLocale ? [...locales, newLocale] : locales;
};

/**
 * Test matching locale against lowercased locale withno - or _ characters
 *
 * @param newLocale - new locale
 * @param existingLocale - existing locale to compare against
 * @returns a boolean indicating if the locale matches
 */
export const isMatchingLocale = (newLocale: string, existingLocale: string) => {
  return (
    !!newLocale &&
    existingLocale
      .replace(/[_-]/, '')
      .toLocaleLowerCase()
      .includes(newLocale.replace(/[_-]/, '').toLocaleLowerCase())
  );
};
